import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CheckMeasurementsProductsComponent } from 'src/app/sections/visualizacionFolder/check-measurements-products/check-measurements-products.component';


const routes: Routes = [
  { path: 'check-measurements-products', component: CheckMeasurementsProductsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CheckMeasurementsProductsRoutingModule { }
